import { useEffect, useState } from 'react'
import { listAssessments } from '~/api/assessment'
import type { AssessmentResponse } from '~/api/types'
import { errMessage } from './utils'

export function useMaintenanceAssessments() {
    const [assessments, setAssessments] = useState<AssessmentResponse[] | null>(
        null
    )
    const [selectedId, setSelectedId] = useState('')
    const [listError, setListError] = useState<string | null>(null)

    useEffect(() => {
        let cancelled = false
        listAssessments()
            .then((items) => {
                if (cancelled) return
                setAssessments(items)
                if (items.length > 0) setSelectedId(items[0].id)
            })
            .catch((err: unknown) => {
                if (cancelled) return
                setAssessments([])
                setListError(errMessage(err, '평가 목록을 불러오지 못했어요.'))
            })
        return () => {
            cancelled = true
        }
    }, [])

    return {
        assessments,
        selectedId,
        setSelectedId,
        listError,
    }
}
